import { createRouter, createWebHistory } from 'vue-router'
// 官网页面
import OfficialWebsite from '@/views/OfficialWebsite.vue'
// 管理系统页面
import Login from '@/views/admin/Login.vue'
import Dashboard from '@/views/admin/Dashboard.vue' // 带侧边栏的父布局
import ContestManagement from '@/views/admin/children/ContestManagement.vue' // 仅保留主办单位组件
import Banner from '@/views/admin/children/Banner.vue'
import Introduction from '@/views/admin/children/Introduction.vue'
import Review from '@/views/admin/children/Review.vue'
import Schedule from '@/views/admin/children/Schedule.vue'
import PlayerWayOut from '@/views/admin/children/PlayerWayOut.vue'
import Collaboration from '@/views/admin/children/Collaboration.vue'
import Register from '@/views/admin/children/Register.vue'
import SystemAdmin from '@/views/admin/children/SystemAdmin.vue'

const routes = [
    // 管理系统登录页
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    // 管理系统父布局（仅保留主办单位子路由）
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'banner',
                name: 'Banner',
                component: Banner
            },
            {
                path: 'contestManagement',
                name: 'ContestManagement',
                component: ContestManagement
            },
            {
                path: 'introduction',
                name: 'Introduction',
                component: Introduction
            },
            {
                path: 'review',
                name: 'Review',
                component: Review
            },
            {
                path: 'schedule',
                name: 'Schedule',
                component: Schedule
            },
            {
                path: 'playerWayOut',
                name: 'PlayerWayOut',
                component: PlayerWayOut
            },
            {
                path: 'collaboration',
                name: 'Collaboration',
                component: Collaboration
            },

            {
                path: 'register',
                name: 'Register',
                component: Register
            },

            {
                path: 'systemAdmin',
                name: 'SystemAdmin',
                component: SystemAdmin
            }

        ]
    },
    // 官网首页
    {
        path: '/',
        name: 'OfficialWebsite',
        component: OfficialWebsite
    },
    // 404 页面
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: { template: '<div style="color: red; padding: 20px; text-align: center;">404 页面未找到</div>' }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
    const isAuthenticated = localStorage.getItem('token')
    if (to.meta.requiresAuth && !isAuthenticated) {
        next('/login') // 未登录跳登录页
    } else if (to.path === '/login' && isAuthenticated) {
        next('/dashboard/contestManagement') // 已登录直接跳主办单位页面（避免空布局）
    } else {
        next()
    }
})

export default router